"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _conditionalRendering = require("./conditionalRendering");
var _checkConditions = require("./checkConditions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var CustomButton = props => {
  var label = props.field.model.title,
    css = props.field.model.cssClass,
    shouldHide;
  var field = props.field,
    fieldId = field.buttonField.id,
    fieldName = field.buttonField.name,
    state = _conditionalRendering.store.getState();
  var conditionId = field.model.conditionSettings.fieldKey;
  if (state !== undefined) {
    if (state.conditions[conditionId] !== undefined) shouldHide = (0, _checkConditions.checkConditions)(state.fieldValues, state.conditions[conditionId]);
  }
  var clicked = () => {
    // window.waitForSubmit=false;
    // NOTE: onButtonClick is not a submit handler;
    // it signals to the parent form which button invoked the submit action
    // (which is important for multi-step forms where multiple submits can occur i.e. back/forward)
    props.onButtonClick(field.buttonField.name);
  };
  if (shouldHide) {
    return null;
  } else {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Button, {
      id: fieldId,
      name: fieldName,
      required: props.required ? props.required : false,
      value: label,
      onClick: clicked,
      className: css,
      type: "submit"
    }, label));
  }
};
var _default = exports.default = CustomButton;